"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./style.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomToggle = function CustomToggle(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      disabled = _ref.disabled,
      checked = _ref.checked,
      onChange = _ref.onChange;
  var isSet = !(typeof checked === 'undefined' || checked === null);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "CustomToggle ".concat(disabled ? 'CustomToggle-disabled' : '')
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "CustomToggle__option CustomToggle__option-left ".concat(isSet && checked ? 'CustomToggle__option-left-selected' : ''),
    onClick: function onClick() {
      return !disabled && onChange(true);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "CustomToggle__text"
  }, options[0])), /*#__PURE__*/_react.default.createElement("section", {
    className: "CustomToggle__option CustomToggle__option-right ".concat(isSet && !checked ? 'CustomToggle__option-right-selected' : ''),
    onClick: function onClick() {
      return !disabled && onChange(false);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "CustomToggle__text"
  }, options[1])));
};

var _default = CustomToggle;
exports.default = _default;